import axios from "axios"

import base from "@/http/path.js"
const httpClient = axios.create({
    baseURL: base.baseUrl,
  });

  export const login = async (username, password) => {
    try {
        const loginDto = {
            UserName: username,
            Password: password,
            // TurnstileToken:turnstileToken
          };

      const response = await httpClient.post(base.loginPoint, loginDto);

      // 使用localStorage存储token
      const token = response.data.token;
      localStorage.setItem('token', token);
      
      return response.data;
    } catch (error) {
      throw error;
    }
  };

//   //修改用户信息
//   export const updateUserInfo = async (userId, userInfo) => {
//     try {
//       // 从localStorage中获取token
//       const token = localStorage.getItem('token');
//       // 设置请求头中的Authorization字段
//       httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  
//       // 发送PUT请求到后端
//       const response = await httpClient.put(`${base.baseUrl+base.putUserInfoEndpoint}${userId}`, userInfo);
  
//       return response;
//     } catch (error) {
//       // 如果响应包含错误消息，抛出该消息
//       if (error.response && error.response.data) {
//         throw new Error(error.response.data.message);
//       }
//       // 否则抛出默认的错误消息
//       throw new Error('更新用户信息失败，请重试。');
//     }
//   };

  
//   //修改用户密码
//   export const mPwd = async (userId, pwdinfo) => {
//     try {
//       // 从localStorage中获取token
//       const token = localStorage.getItem('token');
//       // 设置请求头中的Authorization字段
//       httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  
//       // 发送PUT请求到后端
//       const response = await httpClient.post(`${base.baseUrl+base.postMPwdEndpoint}${userId}`, pwdinfo);
  
//       return response.data;
//     } catch (error) {
//       // 如果响应包含错误消息，抛出该消息
//       if (error.response && error.response.data) {
//         throw new Error(error.response.data.message);
//       }
//       // 否则抛出默认的错误消息
//       throw new Error('更新用户信息失败，请重试。');
//     }
//   };